import { ReleaseStatusEnum } from 'common/constants/enum';
import { PillStatus } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

interface Props {
  value: string;
  style?: StyleObject | any;
}

export default function ReleasePillStatus(props: Props) {
  const { t } = useTranslation();
  const { value, style } = props;
  let status: 'blue' | 'brown' | 'green' | 'red' | 'yellow' | 'other';
  let text: string = '-';

  switch (value) {
    case ReleaseStatusEnum.Requested:
      status = 'green';
      text = t(`status:${value}`);
      break;
    case ReleaseStatusEnum.PendingApproval:
    case ReleaseStatusEnum.PendingReleaseApproval:
    case ReleaseStatusEnum.PendingCancelRefund:
    case ReleaseStatusEnum.Draft:
    case ReleaseStatusEnum.DraftRefund:
    case ReleaseStatusEnum.DraftCancelRefund:
    case ReleaseStatusEnum.PendingRefund:
      status = 'yellow';
      if (value === ReleaseStatusEnum.Draft) {
        text = t('status:draft');
      } else if (
        value === ReleaseStatusEnum.PendingApproval ||
        value === ReleaseStatusEnum.PendingCancelRefund ||
        value === ReleaseStatusEnum.PendingReleaseApproval
      ) {
        text = t('status:waiting_approval');
      } else {
        text = t(`status:${value}`);
      }
      break;

    case ReleaseStatusEnum.RejectedApproval:
    case ReleaseStatusEnum.RejectedReleaseApproval:
    case ReleaseStatusEnum.RejectRefund:
      status = 'red';
      if (
        value === ReleaseStatusEnum.RejectedApproval ||
        value === ReleaseStatusEnum.RejectedReleaseApproval ||
        value === ReleaseStatusEnum.RejectRefund
      ) {
        text = t('status:rejected');
      }
      break;
    case ReleaseStatusEnum.Completed:
    case ReleaseStatusEnum.Waiting:
    case ReleaseStatusEnum.CancelRefund:
    default:
      if (value === ReleaseStatusEnum.Completed) text = t('status:completed');
      if (value === ReleaseStatusEnum.Waiting) text = t('status:waiting');
      if (value === ReleaseStatusEnum.CancelRefund)
        text = t('status:cancel_refund');

      status = 'other';
      break;
  }
  return <PillStatus $style={style} status={status} children={text} />;
}
